/**
 * Created by akrio on 2018/3/23.
 */

export default {
  state: {},
  mutations: {},
  getters: {},
};
